<div class="loader col-md-12">
    <div class="col-md-4"></div>
    <div class="warns col-md-6">
        <span>{{'PAYMENT_IN_PROGRESS' | translate}}</span>
        <img src="../../../../assets/images/updated-ajax-loader.gif">
    </div>
    <div class="col-md-2"></div>
</div>